module.exports = __webpack_public_path__ + "img/ImmerFotos.09d8b88a.svg";